/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';

import { Hidden } from '@coursera/cds-core';

import { numberOfProducts } from 'bundles/coursera-plus-common/utils/courseraPlusUtils';
import CourseraPlusUpsellBanner from 'bundles/unified-common/components/coursera-plus-upsells/CourseraPlusUpsellBanner';
import CourseraPlusUpsellCard from 'bundles/unified-common/components/coursera-plus-upsells/CourseraPlusUpsellCard';

import _t from 'i18n!nls/articles';

const styles = {
  container: css`
    padding: var(--cds-spacing-200) 0;
  `,
  containerLargeVariant: css`
    padding: var(--cds-spacing-400) var(--cds-spacing-200);
    max-width: 1380px;
    margin: 0 auto;
  `,
};

const CPlusElevateLTVPromoUnit = ({ size = 'small' }: { size?: 'large' | 'small' }) => {
  const isLargeVariant = size === 'large';

  const titleWithNumberOfProducts = _t('Unlock #{numberOfProducts} world-class courses and Coursera Coach.', {
    numberOfProducts,
  });
  const titleShort = _t('Build your skills. Boost your career.');
  const descriptionForUpsellBanner = _t(
    'Access #{numberOfProducts} world-class courses, learn more effectively with Coursera Coach, and earn recognized credentials — all with one subscription.',
    {
      numberOfProducts,
    }
  );

  if (isLargeVariant) {
    return (
      <div css={styles.containerLargeVariant}>
        <Hidden smDown>
          <CourseraPlusUpsellBanner height="medium" title={titleShort} description={descriptionForUpsellBanner} />
        </Hidden>
        <Hidden mdUp>
          <CourseraPlusUpsellBanner
            height="small"
            title={titleWithNumberOfProducts}
            description={descriptionForUpsellBanner}
          />
        </Hidden>
      </div>
    );
  }

  return (
    <div css={styles.container}>
      <Hidden xsDown>
        <CourseraPlusUpsellBanner title={titleWithNumberOfProducts} height="small" />
      </Hidden>
      <Hidden smUp>
        <CourseraPlusUpsellCard title={titleWithNumberOfProducts} />
      </Hidden>
    </div>
  );
};

export default CPlusElevateLTVPromoUnit;
